/**
 * Created by ed on 4/10/17.
 */
import React, { Component } from 'react';

class FormErrorDisplay extends Component {

    render () {
        return (
            <div className="error">
                {this.props.errors.join('<br>')}
            </div>
        );
    }
}

export default FormErrorDisplay;


// WEBPACK FOOTER //
// ./src/components/FormErrorDisplay.js